'use strict';

angular.module('buyersService')
.factory('PostService', ['$log', '$rootScope', '$http', '$q', 'CacheFactory', 'Base64', 'appInfo'
    , function ($log, $rootScope, $http, $q, CacheFactory,  Base64, appInfo  ) {

        var service = {};

        var  currentUser = $rootScope.currentUser
        , usercode    = $rootScope.currentUser.authdata
        , activeAgency = $rootScope.currentUser.activeAgency
        , usercode = currentUser.authdata;

        service.getPosts = function(filter, pageSize, showBeforePostId) {
            var dfd = $q.defer();
            var dataParams = { usercode: usercode, pageSize: pageSize, showbeforepostid: showBeforePostId, postType: "1,3" };
            switch(filter.filterType) {
                case 'propertyRelated':
                    dataParams.status = '1';
                    dataParams.propertyRef = filter.propertyRef;
                    break;
            }

            $http({
                    url: appInfo.endpoint + 'agency/getFeed.json', 
                    method: "POST",
                    params: {api_key: appInfo.pkey},
                    data: dataParams,
                 }).success(function(data, status, headers, config) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: Status " + status); 
                });

            return dfd.promise;
        };

        return service;

}]);